import { IAttachedFile } from '../../../redux/types/IAttachedFile';
import IFile from '../../../redux/types/IFiles';
import { StorageService } from '../../services/StorageService';
import { ERROR_OBTAINING_SAS, ERROR_UPLOADING_FILE_SAS, OBTAINED_SAS, REQUEST_SAS, UPLOADING_FILE_SAS, UPLOAD_COMPLETED } from './ContainerDetailsWindowFields';
import { ContainerDetailsWindow } from './ContainerDetailsWindow';

export class LivePerformanceContainerDetailsWindow extends ContainerDetailsWindow {

    componentDidMount() {
        super.componentDidMount();
		this.props.cleanUploadFilesState?.();
		this.props.cleanDroppedFilesRepertoire?.();
    }

    uploadFile(newFile: IFile, path: string, file: any) {
        const { 
            setInDropZone,
            addDroppedFileRepertoire,
            setProgressUploadFileRepertoire,
        } = this.props;

        addDroppedFileRepertoire(newFile, true);

        setInDropZone(false);

        setProgressUploadFileRepertoire(this.viewData[REQUEST_SAS], newFile, false);

        return Promise.resolve(
            StorageService.getUploadUri(path, true).then(
                (uri: string) => {
                    if (uri && uri.length > 0) {
                        setProgressUploadFileRepertoire(this.viewData[OBTAINED_SAS], newFile, false);
                        setProgressUploadFileRepertoire(this.viewData[UPLOADING_FILE_SAS], newFile, false);
                    
                        return StorageService.uploadFile(uri, file).then(
                            (res: boolean) => {
                                if (res) {
                                    setProgressUploadFileRepertoire(this.viewData[UPLOAD_COMPLETED], newFile, true);
                                    return true;
                                }
                            },
                            reject => {
                                setProgressUploadFileRepertoire(this.viewData[ERROR_UPLOADING_FILE_SAS], newFile, true);

                                return false;
                            }
                        )
                            .catch(error => {
                                return false;
                            })
                    }
                },
                reject => {
                    setProgressUploadFileRepertoire(this.viewData[ERROR_OBTAINING_SAS], newFile, true);

                    return false;
                }
            )
        )
    }

    handleDrop = e => {
        const {
            cleanDroppedFilesRepertoire,
            addRepertoireAttachmentToState,
            removeAttachmentIfExists,
            entitySource
        } = this.props;

        const files = [...e.dataTransfer.files];

        cleanDroppedFilesRepertoire();

        files.forEach(file => {
            const newFile: IFile = super.createUploadFile(file);
            const fileToUpload: IFile = { ...newFile };

            fileToUpload.name = crypto.randomUUID();

            const fullPath =
                `repertoireAttachments/usage/${fileToUpload.name}`;

            this.uploadFile(newFile, fullPath, file).then(
                (uploaded: boolean) => {
                    const finalFile: IAttachedFile = {
                        fileName: file.name,
                        guid: fileToUpload.name
                    };

                    if (!uploaded) {
                        removeAttachmentIfExists(
                            finalFile,
                            entitySource
                        );
                    } else {
                        addRepertoireAttachmentToState(finalFile);
                    }
                }
            );
        });

        e.preventDefault();
    };
}